import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDownIcon } from "@heroicons/react/24/outline"; // Replace with your icon setup
import { Project } from "@/types/project";

interface DropdownProps {
  title: string;
  options: Project[] | null;
}

const ProjetDropdown: React.FC<DropdownProps> = ({ title, options }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center space-x-1 text-gray-800">
        <span className="font-bold">{title}</span>
        <ChevronDownIcon className="h-5 w-5" />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {options?.map((option, index) => (
          <DropdownMenuItem key={index}>{option.title}</DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ProjetDropdown;
